export default "__VITE_ASSET__csAC0Loi__"